import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CopyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"copy"}/>
}
